import { Backdrop, Fade, LoadingDots, Paper, Typography } from '@fox/atoms';
import { FlexColumnSpacedLarge, PaddedLarge } from '@fox/layout';

export const LoadingOverlay = ({ loading }: { loading: boolean }) => {
	return (
		<Backdrop sx={{ zIndex: theme => theme.zIndex.drawer + 1 }} open={loading}>
			<Fade
				in={loading}
				style={{
					transitionDelay: '0ms'
				}}
				exit={true}
				unmountOnExit
			>
				<Paper elevation={2}>
					<PaddedLarge>
						<FlexColumnSpacedLarge style={{ alignItems: 'center', justifyContent: 'center' }}>
							<LoadingDots size="large" />
							<Typography align="center" variant="h4">
								Processing form submission
							</Typography>
							<Typography align="center" variant="h5">{`Please don't close this window`}</Typography>
						</FlexColumnSpacedLarge>
					</PaddedLarge>
				</Paper>
			</Fade>
		</Backdrop>
	);
};
